import { createApiMiddleware, NAMESPACE as REQUESTS_NAMESPACE, requestsReducer } from "App/apiMiddleware";
import listenerMiddleware from "App/listenerMiddleware";
import { NAMESPACE as POPUP_MESSAGE_NAMESPACE, reducer as popupMessageReducer } from "App/popupMessage";
import { routingMiddleware, routingReducer } from "App/routing";
import { NAMESPACE as ABOUT_PAGE_NAMESPACE, reducer as aboutReducer } from "Areas/About";
import { NAMESPACE as DOCUMENTS_NAMESPACE, reducer as documentsReducer } from "Areas/Documents";
import { NAMESPACE as PROJECTS_NAMESPACE, reducer as projectsReducer } from "Areas/Projects";
import { NAMESPACE as SETTINGS_PAGE_NAMESPACE, reducer as settingsReducer } from "Areas/Settings";
import { NAMESPACE as ACCESS_LEVELS_FEATURE_NAMESPACE, reducer as accessLevelsReducer } from "Areas/SharedFeatures/accessLevels";
import { NAMESPACE as ACCESS_LEVELS_EDITOR_PANEL_FEATURE_NAMESPACE, reducer as accessLevelsEditorPanelReducer } from "Areas/SharedFeatures/accessLevelsEditorPanel";
import { NAMESPACE as DOWNSIDE_PANEL_FEATURE_NAMESPACE, reducer as downSidePanelReducer } from "Areas/SharedFeatures/downSidePanel";
import { NAMESPACE as RIGHT_SIDE_DETAILS_PANEL_FEATURE_NAMESPACE, reducer as rightSideDetailsPanelReducer } from "Areas/SharedFeatures/rightSideDetailsPanel";
import signalRMiddleware from "Areas/SharedFeatures/signalRMiddleware";
import { NAMESPACE as TASKS_LOGS_FEATURE_NAMESPACE, reducer as tasksLogsReducer } from "Areas/SharedFeatures/tasksLogs";
import { NAMESPACE as SIDEBAR_NAMESPACE, reducer as sidebarReducer } from "Areas/Sidebar";
import { NAMESPACE as SUMMARY_REPORTS_NAMESPACE, reducer as summaryReportsReducer } from "Areas/SummaryReports";
import { NAMESPACE as WORK_SPACES_PAGE_NAMESPACE, reducer as workSpacesReducer } from "Areas/WorkSpaces";
import { fileResponseProcessor } from "Common/api/apiMiddleware.utils";
import { REDUX_ROUTER_NAMESPACE, REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils";
import { applyMiddleware, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
import { createReduxHistory, routerMiddleware, routerReducer } from "./connectRoutes";
const getMiddlewares = (testEnvironment) => {
    const items = [
        thunk,
        createApiMiddleware({ responseProcessor: fileResponseProcessor }),
        routerMiddleware,
        routingMiddleware,
        listenerMiddleware
    ];
    if (!testEnvironment) {
        items.push(signalRMiddleware);
    }
    return applyMiddleware(...items);
};
const getEnhancers = (testEnvironment) => compose(getMiddlewares(testEnvironment));
export { createReduxHistory, getEnhancers };
export default combineReducers({
    [SETTINGS_PAGE_NAMESPACE]: settingsReducer,
    [ABOUT_PAGE_NAMESPACE]: aboutReducer,
    [TASKS_LOGS_FEATURE_NAMESPACE]: tasksLogsReducer,
    [SIDEBAR_NAMESPACE]: sidebarReducer,
    [WORK_SPACES_PAGE_NAMESPACE]: workSpacesReducer,
    [PROJECTS_NAMESPACE]: projectsReducer,
    [DOCUMENTS_NAMESPACE]: documentsReducer,
    [ACCESS_LEVELS_FEATURE_NAMESPACE]: accessLevelsReducer,
    [ACCESS_LEVELS_EDITOR_PANEL_FEATURE_NAMESPACE]: accessLevelsEditorPanelReducer,
    [DOWNSIDE_PANEL_FEATURE_NAMESPACE]: downSidePanelReducer,
    [RIGHT_SIDE_DETAILS_PANEL_FEATURE_NAMESPACE]: rightSideDetailsPanelReducer,
    [SUMMARY_REPORTS_NAMESPACE]: summaryReportsReducer,
    [REQUESTS_NAMESPACE]: requestsReducer,
    [REDUX_ROUTER_NAMESPACE]: routerReducer,
    [REDUX_ROUTING_PAGE_NAMESPACE]: routingReducer,
    [POPUP_MESSAGE_NAMESPACE]: popupMessageReducer
});
